<template lang="html">
  <div class="">
    <button class="btn btn-danger" type="button" name="button" @click="setEnd">
       END
    </button>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: "EndImpression",
  props : [
    "line"
  ],
  data() {
    return {};
  },
  methods: {
    show () {
         this.$modal.show('printline-modal'+this.line.rowid);
    },
    hide () {
          this.$modal.hide('printline-modal'+this.line.rowid);
    },
    setEnd(){
      //set end date of ofile for statistics purpose
      axios
        .post(
          "/api/index.php/of/setlineend",
          {lineid:this.line.rowid},
          {
            headers: {
              'DOLAPIKEY': 'bb30b37967cc61e97da43f53467e94ca1c0fabf9'
            }
          }
        )
        .then(response => {
          console.log(response);
          //if first print set start date
          this.$emit('impressionend',response);
          this.hide();
        });
    }
  },


}
</script>

<style lang="css" scoped>
.thumb-preview-item img{
  max-width: 200px;
  max-height: 200px;
}


</style>
<style media="screen">
.vm--modal{
  top: 10% !important;
  left: 15% !important;
  width: 80% !important;
  height: 80% !important;
}
</style>
